import React, { FC } from 'react';

import { File } from 'api-client';
import download from 'assets/images/svg/download.svg';
import { Image } from 'components/common';
import FileSize from 'components/common/utils/FileSize/FileSize';

import styles from './NotificationFile.module.scss';

interface Props {
  file: File;
}

const NotificationFile: FC<Props> = ({ file }) => (
  <div className={styles.file}>
    <div className={styles.info}>
      <span className={styles.name}>{file.name}</span>
      <span className={styles.size}>
        <FileSize file={file} />
      </span>
    </div>
    <a href={file.url} target="_blank" rel="noreferrer noopener" className={styles.link}>
      <Image src={download} alt="" className={styles.icon} />
      <span>Скачать</span>
    </a>
  </div>
);

export default NotificationFile;
